// import { NumberValidator } from "ng2-validation";

export class UserSignInInfo {
  email: string;
  password: string;
}

export class UserPassword {
  userId: number;
  password: string;
}

export class UserForgotPassword {
  email: string;
}

export class Token {
  tokenId: number;
  userId: number;
  token: string;
  role: string;
}

export class CardDetails {
  customerId: string;
  credits: number;
  activeCard: string;
  cardType: string;
}

export class UserDetails {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  company = new Company();
  role: string[] | string;
  password: string;
  createdBy: number;
  status: string;
  timeZone: string;
  uid: string;
  restoreid: string;
  brands: string;
  fetchedFromCache?: boolean;
}

export class AssociateInfo {
  userId: number;
  brandId: number;
}

export class Brand {
  id: number;
  brandName: string;
  companyId: number;
  createdBy: number;
  modifiedBy: number;
}


export class Company {
  companyId: number;
  name = "";
}

export class SourceToken {
  token: string;
  expires: number;
  machineId = "";
}

export class apiToken {
  apikeyid;
  userId;
  apikey;
  token_name;
  validUpto;
}

export class Column {
  name: string;
  type: string;
  mode = "NULLABLE";
  fields: Column[] = [];
  primary = false;
  lastRecord = false;
  selected = false;
  modificationType = "NONE";
  exclusionFields: string[] = [];
}

export class TableNames {
  tables: Tables[] = [];
  configtables: Tables[] = [];
}

export class Table {
  name: string;
  columns: Column[];
  storage: Storage;
  schema: string;
  selected: boolean;
  pivotColumn?: Column;
  modificationType = "NONE";
}

export class Storage {
  basePath: string;
  blobPath: string;
}

export class Source {
  sourceId: number;
  userId: number;
  name: string;
  type: string;
  shopName: string;
  frequency = 2;
  history = 1;
  datasourceId: number;
  settings: SourceSettings = new SourceSettings();
  status: string;
  sourceUid: any;
  destinationType: string;
}

export class SourceAccount {
  accountId: string;
  name: string;
  selected = false;
}

export class SourceSettings {
  token: SourceToken = new SourceToken();
  defaultColumns = false;
  accounts: string[];
  tables: Table[];
  props: { [key: string]: string };
}

export class Datasource {
  id: number;
  categoryName: string;
  sourceId: number;
  cdkSource?: boolean;
  displayName: string;
  displayDesc: string;
  displayCategory: number;
  logoUrl: string;
  settings: DatasourceSettings;
  loginType: string;
  status: string;
  type: string;
  category: DatasourceCategory;
  renewImplemented: boolean;
  beta: boolean;
  template?: boolean;
  dashboard?:boolean;
  isCdk: boolean;
  isLegacy: boolean;
  templateId?: any;
  planType?: 'TRIAL' | 'LITE' | 'GROWTH' | 'ENTERPRISE';
  associatedPlan?: string;
  dataSource: any;
}

export class DatasourceResponse {
  data: {
    productLeverList: Array<{
      masterId: any;
      name: string;
      category: string;
      displayName?: string;
      description?: string;
      subscriptionPlans: Array<{
        subscriptionPlanGroup: 'LITE' | 'GROWTH' | 'ENTERPRISE';
        basePrice?: number;
        description?: string;
      }>;
    }>;
  };
}

export class DatasourceSettings {
  version: number;
  preAuthSteps: Step[];
  postAuthSteps: Step[];
  templateSteps?: Step[];
  dashboardSteps?: Step[];
}

export class Step {
  header: string;
  type: string;
  attributes: InputAttribute[];
  notifyFieldAddDrop: boolean;
}

export class DatasourceCategory {
  categoryId: number;
  category: string;
}

export class StepFile {
  fileId: string;
  filePath: string;
}

export class AllStepsFiles {
  files: StepFile[];
}


export class GAInputAttribute {
  index: number;
  table: string;
  tableName: InputAttribute;
  dimensions: InputAttribute;
  metrics: InputAttribute;
  period: InputAttribute;
  dimensionselectedList: string[];
  metricselectedList: string[];
  created: boolean;
  errorMessage: string;
  updateMode?: string;
  maxDimension?: boolean;
  maxMetricx?: boolean;

}

export class CustomTableAttribute {
  index: number;
  table: string;
  tableName?: InputAttribute;
  dimensions?: InputAttribute;
  resources?: InputAttribute;
  metrics?: InputAttribute;
  metrics_option?: InputAttribute;
  breakdowns?: InputAttribute;
  actionBreakdowns?: InputAttribute;
  dimensionselectedList?: string[];
  resources_optionselectedList?: string[];
  metricselectedList?: string[];
  metrics_optionselectedList?: string[];
  created: boolean;
  errorMessage: string;
  updateMode?: string;
  maxDimension?: boolean;
  maxMetricx?: boolean;
  maxMetrics_option?: boolean;
  breakdowns_optionselectedList?: string[];
  actionBreakdowns_optionselectedList?: string[];
}

export class CustomIterable {
  tableName: InputAttribute;
  table: string;
  created: boolean;
  errorMessage: string;
  index: number;
  // tableNameList: string[];
  dimensions: InputAttribute;
  dimensionselectedList: string[];
}
export class SnapAdsInputAttribute {
  tableName: InputAttribute;
  metrics: InputAttribute;
  metricselectedList: string[];
}
export class GSCInputAttributes {
  tableCheck: InputAttribute;
  iterableData: CustomIterable[]; // = new CustomIterable();
}

export class CustomInputAttributes {
  tableCheck: InputAttribute;
  createdTables: CustomTableAttribute[];
  innerAttributes: InputAttribute[];
}

export class InputAttribute extends GAInputAttribute {
  value: string;
  label: string;
  name: string;
  type: string;
  required: boolean;
  maxLength: number;
  selected: boolean;
  min: number;
  max: number;
  possibleValues: GroupId[];
  childAttribute: InputAttribute[];
  autoCompleteUrl: string;
  help: string;
  description: string;
  selectedList: string[];
  markChildAttribute: boolean;
  newlyAdded: boolean;
  showSelectAll: boolean;
  pivot: boolean;
  teaser: string;
  validated = true;
  fileName: string;
  fileType: string;
  customColumnAlias: string;
  customColumnDefaultType: string;
  customColumnUserDefined: string;
  editCustomColumn: boolean;
  customColumnName: string;
  errorMessage: string;
  ifAddButton?: boolean;
  ifRemoveButton?: boolean;
  attrInputIndex?: number;
  tableFilterData?: GroupId[];
  selectedTables?: GroupId[]; // TableVirtualScrollDataSource<any>;
  // selectedPossibleValues?: GroupId[];
  hasFocus = false;
  searchTableStr: string;
  multiselect?: boolean;
  parentAttribute?: string;
  showOnParentValue?: string[];
  ifEditable: boolean = false;
  displayOnly: boolean = false;
  disabled: boolean = true;
  googleAdsStatus?: boolean;
  loader?: boolean = false;
  initialNumOfRecords: number;
  toolTip: any;
  maxAllowDays: number;
  maxASINPerMonth?: number;
  maxASINPerWeek?: number;
  hasMutualExclusiveColumn?: boolean;
}

// can merge with inputAttribute later
export class Preference {
  value: string;
  label: string;
  name: string;
  type: string;
  required: boolean;
  // below commented are removed/difference of inputAttribute model
  // maxLength: number;
  // selected: boolean;
  // above commented are removed/difference of inputAttribute model
  min: number;
  max: number;
  possibleValues: GroupId[];
  // below commented are removed/difference of inputAttribute model
  // childAttribute: InputAttribute[];
  // autoCompleteUrl: string;
  // help: string;
  // description: string;
  // selectedList: string[];
  // markChildAttribute: boolean;
  // newlyAdded: boolean;
  // showSelectAll: boolean;
  // pivot: boolean;
  // teaser: string;
  // validated = true;
  // fileName: string;
  // fileType: string;
  // above commented are removed/difference of inputAttribute model
  preferenceGroupId: number;
  grouplabel: string;
  preferenceId: number;
  entityType: string;
  enforced: boolean;
}

export class CurrentPreference {
  preferenceId: number;
  value: string;
  entityType: string;
  enforced: boolean | null;
}

export class CatogarizedPossibleValues {
  item: GroupId[];
  catogery: string;
}

export class IntegrationName {
  sourceId: number;
  name: string;
  userid: number;
}

export class EmailList {
  companyid: number;
  email: string;
  userid: number;
}
export class TableFilter {
  name: string;
  default: string;
  required = false;
  selected = false;
}

export class GroupId {
  active: boolean;
  value: string;
  group: string;
  fullLoadSupported: boolean; // reverted to fullLoadSupported as suggested by KK
  selected: boolean;
  disabled: boolean;
  category?: string;
  exclusionFields: string[];
  exclusionTables?: string[];
  inclusionTables?: string[];
  excludeFromSelectAllTables?:boolean = false;
  yahoogeminiDim?: string[];
  yahoogeminiAdd?: boolean;
  canSelect?: boolean;
  aliasName?: string;
  maxDepthOfNesting?: string;
  updateMode?: string;
  primary?: boolean;
  dataTypeInferred?: string;
  dataTypeOverride?: string;
  otherInfo?: boolean;
  childAttribute: InputAttribute[];
  selectedList = [];
  aliasUniqueConstraint = false;
  data: GroupData[];
  type?: String;
  dataType?: string;
  userDefinedDataType: string;
  customColumnPattern?: string;
  primaryKey?: boolean; // default value of primary key
  deprecatedTable?: boolean = false;
  canUnselect?: boolean = true;
  domain?: string[];
  enableHashing?: boolean = false;
  beta?: boolean = false;
  frequency?: string;
  history?: string;
  cronDescription: string = undefined;
  toggleHistory?: boolean = false;
  tableFrequency?: number;
  allowedFrequencies?: string[] = [];
  defaultFrequency?: string;
  description?: string;
  toolTip?: string;
  deleted?: boolean = false;
  profileActive: boolean;
  accountStatus: string;
  accountType: string;
  accountName?: string;
}

export class GroupData {
  name: string;
  value: string;
}

export class WarehouseToken {
  token: string;
  expires: number;
  tokenType: string;
}

export class WarehouseAccount {
  accountId: string;
  name: string;
  selected = false;
}

export class WarehouseSetting {
  version: number;
  token: WarehouseToken;
  accounts: string[];
  projectName: string;
  preAuthSteps: Step[];
  postAuthSteps: Step[];
}

export class Warehouse {
  warehouseId: number;
  userId: number;
  name: string;
  type: string;
  datawarehouseId: number;
  status: string;
  settings: WarehouseSetting = new WarehouseSetting();
  created: number;
}

export class EnabledWarehouse {
  warehouseId: number;
  userId: number;
  created: number;
  logoUrl: string;
  name: string;
  status: string;
  type: string;
  numberOfSources?: number;
  displayStatus?: string;
  settingStatus?: boolean;
  createdDate?: string;
  count?: number;
  sources?: string[];
  no_dest_sources?: any[];
}

export class Datawarehouse {
  datawarehouseId: number;
  displayName: string;
  displayDesc: string;
  logoUrl: string;
  status: string;
  type: string;
  settings: WarehouseSetting = new WarehouseSetting();
  loginType: string;
}

export class TrustedBusinesses {
  image_url: string;
}

export class Subscription {
  name: string;
  rowsInMillion: any;
  price: any;
  extraPerMillion: any;
  noOfIntegrations: any;
  subscriptionPlanId: number;
  onBoarding: string;
  customerSuccessManager: string;
  discounting1: string;
  discounting2: string;
  enterpriseStatus: boolean;
  planType: number;
  description: string;
}

export class UserSubscription {
  userId: number;
  subscriptionPlanId: number;
}

export class CheckoutData {
  planId: string;
  subscriptionPlanId: number;
  userId: number;
  checkoutType: number;
  hostpageId: string;
  chargebeeSubscriptionId: string;
}

export class SourceUpdateData {
  sourceId: number;
  status: any;
  userId: number;
}

export class StepProceed {
  number: number;
  forward: Boolean;
  selector: string;
}

export class StepData {
  stepNumber: number;
  selection: { [key: string]: string[] };
  stepType: string
}

export class CreateSourceRequest {
  source: Source;
  otherInfo: any;
}

export class Notification {
  notificationId: number;
  userId: number;
  name: string;
  type: string;
  message: string;
  createdDate: number;
  updatedDate: number;
  status: string;
  mode: string;
  minsBack: string;
  title?: string;
}

export interface NotificationResult {
  result: string;
}

export class IntegrationDetails {
  summary: Summary = new Summary();
  warehouse: string;
  topDetails: TopDetail[];
  sourceDetails: SourceDetails = new SourceDetails();
}

export class SourceDetails {
  sourceId: number;
  status: string;
  sourceName: string;
  integrationName: string;
  sourceStatus: string;
}

export class TopDetail {
  transactionId: number;
  sourceId: number;
  userId: number;
  startTime: number;
  endTime: number;
  records: number;
  timeTaken: number;
}

export class Summary {
  totalJobRuns: number;
  avgJobTime: number;
  totalRowProcessed: number;
  from: number;
  to: number;
  created: number;
  updated: number;
  userId: number;
}

export class DashboardStats {
  rowsProcessed: DashboardStat = new DashboardStat();
  jobRuns: DashboardStat = new DashboardStat();
  avgJobTime: DashboardStat = new DashboardStat();
}

export class DashboardStat {
  total: number;
  ycoordinate: string[];
  xcoordinate: string[];
}

export class LineChartData {
  data: string[] = [];
  label: string;
}

export class IntegrationTableData {
  endTime: number;
  endTimeDisplay: string;
  error: string;
  integrationName: string;
  logoUrl: string;
  records: number;
  sourceId: number;
  startTime: number;
  startTimeDisplay: string;
  createdTime: number;
  createdTimeDisplay: string;
  updatedTime: number;
  updatedTimeDisplay: string;
  status: string;
  takenTime: string;
  transactionId: number;
  userId: number;
  created: number;
  mostRecentJob: number;
}

export class CurrentCycleStats {
  rowsWritten: number;
  dataLoad: number;
  avgLoadTime: number;
  from: number;
  to: number;
}

export class RowsProcessedStats {
  total: number;
  ycoordinate: string[];
  xcoordinate: number[];
}

export class JobsProcessedStats {
  total: number;
  xcoordinate: number[];
  ycoordinate: string[];
}

export class IntegrationsStats {
  months: string[];
  enabled: number[];
  disabled: string[];
}

export class GraphPostInfo {
  from: number;
  to: number;
  type: number;
}

export class LogData {
  totalCount: number;
  logs: PagedLogs[];
}

export class PagedLogs {
  jobId: number;
  transactionlogid: number;
  integrationName: string;
  integrationType: string;
  startTime: number;
  endTime: number;
  errorCode: number;
  errorType: string;
  tableName: string;
  rowsProcessed: number;
}

export class ConfiguredTable {
  tableHeading: string;
  tableFields: string[];
}

// export class LogMessageTableCreation{
//   tableName : string;
//   records : number;
//   jobId : number;
//   sourceId : number;
//   jobStatus : string;
//   error : string;
// }
export class ConfiguredSource {
  tables: Table[];
  accounts: string[];
}

export class SourceLimit {
  condition: boolean;
  message: string;
}


export interface PanelTableInfo {
  company: string;
  table_name: string;
  job_status: string;
  job_run_time: string;
  last_job_status: string;
  message: string;
  log: string;
  schedule_time: string;
  action: string;
}

export class RunningSource {
  sourceId: number;
  company: string;
  // table_name: string;
  loader: boolean;
  source_status: string;
  source_run_time: string;
  sourceName: string;
  userId: number;
  userName: string;
  sourceType: string;
  running: boolean;
  since: number;
  sourceStatus: string;
}

export class ActiveIntegration {
  sourceId: number;
  integrationName: string;
  sourceLogoUrl: string;
  messageType: string;
  settingStatus: boolean;
  datasourceId: number;
  status: string;
  userId: number;
  nextSyncInfo: string;
  lastSyncTime: string | undefined;
  lastSyncStatus: string;
  warehouseError: boolean = false;
  errorTables: boolean;
  ifStartNowClicked: boolean;
  switchLoading: boolean;
  loginType: string;
  type: string;
  description: string;
  tableFetchingLoader = false;
  rows_processed?: number
  displayStatus?: string;
  destlogoUrl?: string = "";
  destinationName?: string | null;
  logoUrl?: string = "";
  groupName?: string;
  isLegacy?: boolean;
  cdkSource?: boolean;
  templateId: any;
  migrated?: boolean;
}

export class PausedIntegration {
  sourceId: number;
  integrationName: string;
  settingStatus: boolean;
  datasourceId: number;
  logoUrl: string;
  userId: number;
  lastSyncTime: string;
  lastSyncStatus: string;
  switchLoading: boolean;
  errorTables: boolean;
  type: string;
  description: string;
  tableFetchingLoader = false;
  status: string = "PAUSED";
  displayStatus?: string;
  destlogoUrl?: string = "";
  destinationName?: string | null;
  groupName?: string;
  isLegacy?: boolean;
  cdkSource?: boolean;
  migrated?: boolean;
}

export class DeletedIntegration {
  sourceId: number;
  integrationName: string;
  datasourceId: number;
  settingStatus: boolean;
  logoUrl: string;
  userId: number;
  lastSyncTime: string;
  lastSyncStatus: string;
  errorTables: boolean;
  type: string;
  description: string;
  tableFetchingLoader = false;
  status: string = "DELETED";
  displayStatus?: string;
  destlogoUrl?: string = "";
  destinationName?: string | null;
  groupName?: string;
  isLegacy?: boolean;
  cdkSource?: boolean;
  migrated?: boolean;
}

export class HoldIntegration {
  sourceId: number;
  integrationName: string;
  datasourceId: number;
  settingStatus: boolean = false;
  logoUrl: string;
  userId: number;
  type: string;
  displayStatus?: string;
  destlogoUrl?: string = "";
  destinationName?: string | null;
  isLegacy?: boolean;
  cdkSource?: boolean;
  migrated?: boolean;
}

/** Statuses for which an integration row may open the integration-details page. */
export const DETAILS_ROUTABLE_STATUSES: readonly string[] = ['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'];

/** Payload passed from listing cell renderers into parent `routeToDetails`. */
export interface IntegrationRef {
  integrationName: string;
  sourceId: string | number;
  status: string;
  destinationName?: string | null;
}

/**
 * Returns whether an integration row can navigate to integration-details.
 * @param status listing row status
 * @param hasDestination whether destinationName is set (not null/undefined)
 * @returns true when both status and destination allow navigation
 */
export const canOpenIntegrationDetails = (status: string, hasDestination: boolean): boolean =>
  hasDestination && DETAILS_ROUTABLE_STATUSES.includes(status);

export class Sortoption {
  value: string;
  viewValue: string;
}
export class Datebetween {
  value: string;
  viewValue: string;
}

export class Tables {
  name: string;
  columns: Column[];
  storage: Storage;
  schema: string;
  selected: boolean;
  pivotColumn?: Column;
  modificationType = "NONE";
  expandableStatus = false;
  displayName?: string;
  disabled?: boolean;
  status?: string;
  dropdown?: boolean;
  isjobsFetched?: boolean;
  timeStripLoading?: boolean;
  lastRecordProcessed?: string;
  uniwareFacilityError?: string;
  fullLoad?: boolean;
  tableId: any;
  showRequestDataButton?: boolean;
}

export class JobDetails {
  jobId: number;
  rowsprocessed: number;
  status: string;
  startTime: string;
  endTime: string;
  errorType: number;
  error: string;
  errorMessage: string;
  sourceId: number;
  errordescription: string;
  transactionLogId: number;
  tableName: string;
  processedDateTime?: string;
  logs: SourceTransactionLog[];
  timestamp?: { index: number; timestamp: string };
  reportStatus?: {loading: boolean; callstatus: string; color: string}
}

export class SourceTransactionLog {
  timestamp: number;
  message: string;
}

export class SelectedJob {
  jobs: JobDetails[];
  index: number;
  //   timestamp?: string;
}

export class PaginationInfo {
  pageSize?: number;
  pageIndex: number;
  type: string;
}

export class Invoices {
  InvoiceId: string;
  BaseAmount: number;
  Overages: number;
  Amount: number;
  ReceiptURL: string;
  date: Date;
}
export class IntegrationConfigStatus {
  transactionLogId: number;
  sourceTransactionExtrasDetails: SourceTransactionExtraDetail[];
  jobStatus: string;
}
export class SourceTransactionExtraDetail {
  reportId: string;
  status: string;
  startDate: string;
  endDate: string;
}
export class ReportCategory {
 reportCategory:string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export interface IProduct {
  id: number;
  created: number;
  updated: number;
  productName: string;
}

export interface ISubscriptionPlan {
  id: number;
  created: number;
  updated: number;
  name: string;
  basePrice: number;
  product: IProduct;
  status: number;
  description: string;
  managedBySarasOnly: boolean;
  subscriptionPlanIdentifier: string;
  subscriptionPlanGroup: string;
  billingType: string;
  billingDays: number;
  chargebeePlanId: string;
  subscriptionPlanFeatures: any;
}

export interface ICompanySubscription {
  id: number;
  created: number;
  updated: number;
  companyId: number;
  subscriptionPlan: ISubscriptionPlan;
  targetSubscriptionPlan: ISubscriptionPlan | null;
  status: string;
  chargebeeCustomerId: string;
  chargebeeSubscriptionId: string;
  nextBillingDate: number;
  cycleStartDate: number;
  gracePeriod: number;
  overageBillingStartDate: number;
  overageBillingEndDate: number;
}
